
import { LanguagesConfig } from "@/models/dossier-configs/languages";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { IsoLangMap, isoLangs, LanguageNamesDict, getTranslatedIsoLangName, getTranslatedIsoLangNames } from "../../../utils/languages";

export default Vue.extend({
	data() {
		return {
			input: "",
			translatedNames: {} as LanguageNamesDict
		};
	},
	props: {
		languages: Object as () => LanguagesConfig
	},
	computed: {
		matchedLangs(): ISelectItem<string>[] {
			return this.availableLanguagesList.filter(l => {
				if (l.text.toString().toLowerCase().match(this.input.toLowerCase())){
					return true;
				}
				if (l.value.match(this.input.toLowerCase())){
					return true;
				}
				return false;
			});
		},
		availableLanguages():IsoLangMap {
			let allLangs = {...isoLangs};
			for (let lang of this.languages.LanguageNames){
				delete allLangs[lang];
			}
			return allLangs;
		},
		availableLanguagesList():ISelectItem<string>[]{
			let langs = [] as ISelectItem<string>[];
			for (let key of Object.keys(this.availableLanguages)){
				let obj = {
					value: key,
					text: getTranslatedIsoLangName(key, this.translatedNames)
				};
				langs.push(obj);
			}
			return langs;
		},
		selectedLang():string | undefined {
			if (this.input == ""){
				return undefined;
			}
			for (let lng of this.availableLanguagesList){
				if (lng.text.toString().toLowerCase() == this.input.toLowerCase()){
					return lng.value;
				}
			}
			return undefined;
		}
	},
	watch: {
		async input(newVal: string) {
			this.input = this.input.trim();
		},
	},
	methods: {
		langClicked(lang: string) {
			this.input = lang;
		},
		addLanguage() {
			if (!this.languages) return;
			if (!this.selectedLang) return;
			this.languages.LanguageNames.push(this.selectedLang);
			this.$emit("close");
		},
		close() {
			this.$emit("close");
		}
	},
	async mounted() {
		this.translatedNames = await getTranslatedIsoLangNames();
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
